import { Pipe, PipeTransform } from '@angular/core';
import { Request } from '../../classes/request';

@Pipe({
    name: 'internalManagementFilter',
    pure: false
})
export class InternalManagementFilterPipe implements PipeTransform {
    transform(requestList: Array<Request>, filterValue: string): Array<Request> {
        if (!requestList || !filterValue) {
            return requestList;
        }
        const internal = filterValue === 'yes';
        return requestList.filter(request => !!request.InternalManagement === internal);
    }
}
